module.exports = __webpack_public_path__ + "64bebd9a3b3e28540202503ce47ddefb.pdf";